import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-ticket-info',
  name: '票种信息',
  icon: '价',
  group: '门票详情',
  description: '票种价格、名称、标签、月销量及服务/须知摘要。',
  defaultProps: {
    showTags: true,
    showSales: true,
    showService: true,
    showNotice: true
  }
}
